export default __webpack_public_path__ + "images/512x512.png";